module.exports = __webpack_public_path__ + "e54f34d22fa66d5553078812820ee8fc.ttf";